"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaderboardHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ph_domain_1 = require("@phantom/ph-domain");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = require("react");
var default_luck_png_1 = __importDefault(require("../../assets/races/default-luck.png"));
var useMoneyFormatter_1 = require("../../hooks/useMoneyFormatter");
var useTimer_1 = __importDefault(require("../../hooks/useTimer"));
var IPostMessage_1 = require("../../interfaces/IPostMessage");
var helpers_1 = require("../../utilities/helpers");
var postMessages_1 = require("../../utilities/postMessages");
var Modal_1 = __importDefault(require("../modal/Modal"));
var LeaderboardHeaderSubItem_1 = require("./LeaderboardHeaderSubItem");
var LeaderboardHeader = function (_a) {
    var containerClassName = _a.containerClassName, columns = _a.columns, data = _a.data, currency = _a.currency, isSchedule = _a.isSchedule, games = _a.games;
    var _b = (0, react_1.useState)(false), openModal = _b[0], setOpenModal = _b[1];
    var _c = (0, react_1.useState)(false), rulesModal = _c[0], setRulesModal = _c[1];
    var tournamentRules = (0, react_1.useMemo)(function () {
        if (data.assets) {
            var rulesAsset = (0, helpers_1.getAsset)(data.assets, ph_domain_1.AssetType.rulesContent, { lang: "en" });
            return rulesAsset === null || rulesAsset === void 0 ? void 0 : rulesAsset.value;
        }
        return "";
    }, [data.assets]);
    var moneyFormat = (0, useMoneyFormatter_1.useMoneyFormatter)().moneyFormat;
    var _d = (0, useTimer_1.default)(isSchedule ? data.start : data.end), secondsLeft = _d.secondsLeft, seconds = _d.seconds, hours = _d.hours, days = _d.days, minutes = _d.minutes;
    var formatDays = function (days, hours) {
        if (!days) {
            return "".concat((0, helpers_1.addTrailingZero)(hours), "h");
        }
        return "".concat((0, helpers_1.addTrailingZero)(days), "z ").concat((0, helpers_1.addTrailingZero)(hours), "h");
    };
    var getDurationType = function (value, durationType) {
        switch (durationType) {
            case "days":
                if (value === 1) {
                    return "zi";
                }
                return "zile";
            case "hours":
                if (value === 1) {
                    return "ora";
                }
                return "ore";
            default:
                if (value === 1) {
                    return "minut";
                }
                return "minute";
        }
    };
    var _e = (0, react_1.useMemo)(function () {
        var startTime = new Date(data.start).getTime();
        var endTime = new Date(data.end).getTime();
        var diff = endTime - startTime;
        var _a = (0, helpers_1.getTimerDetails)(diff / 1000), days = _a.days, hours = _a.hours, minutes = _a.minutes;
        if (days) {
            return {
                duration: days,
                type: "days",
            };
        }
        if (hours) {
            return {
                duration: hours,
                type: "hours",
            };
        }
        return {
            duration: minutes,
            type: "minutes",
        };
    }, [data, isSchedule]), duration = _e.duration, type = _e.type;
    var defaultColumns = (0, react_1.useMemo)(function () {
        if (!columns) {
            var cols = [];
            cols.push({
                title: "Total premii",
                mainText: moneyFormat(data.totalPrizes),
                secondaryText: currency,
            });
            if (secondsLeft < 0) {
                cols.push({
                    title: "Timp ramas",
                    mainText: "INCHEIATA",
                });
            }
            else {
                cols.push({
                    title: isSchedule ? "Incepe in" : "Timp ramas",
                    mainText: formatDays(days, hours),
                    secondaryText: "".concat((0, helpers_1.addTrailingZero)(minutes), ":").concat((0, helpers_1.addTrailingZero)(seconds)),
                });
            }
            cols.push({
                title: "Durata",
                mainText: duration,
                secondaryText: getDurationType(duration, type),
            });
            cols.push({
                title: "Participanti",
                mainText: "".concat(data.totalPlayers),
                secondaryText: data.totalPlayers === 1 ? "jucator" : "jucatori",
            });
            return cols;
        }
        return columns;
    }, [columns, data, secondsLeft, isSchedule]);
    var onCloseModal = function () {
        setOpenModal(false);
    };
    var onOpenModal = function () {
        setOpenModal(true);
    };
    var onImgError = function (e) {
        e.currentTarget.src = default_luck_png_1.default;
    };
    var openRulesModal = function () {
        setRulesModal(true);
    };
    var onCloseRulesModal = function () {
        setRulesModal(false);
    };
    var openGame = function (gameId) { return function () {
        (0, postMessages_1.internalPostMessage)((0, postMessages_1.createMessage)(IPostMessage_1.EhubMessages.EHUB_START_GAME, {
            gameId: gameId,
        }));
    }; };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [tournamentRules && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "leaderboard-rules" }, { children: (0, jsx_runtime_1.jsx)("button", __assign({ onClick: openRulesModal }, { children: "?" })) }))), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)((0, helpers_1.handleClassNames)("leaderboard-header", containerClassName), isSchedule && "leaderboard-header--schedule") }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "leaderboard-header--wrapper" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ onClick: onOpenModal, className: "leaderboard-header--logoWrapper" }, { children: (0, jsx_runtime_1.jsx)("img", { className: "leaderboard-header--logo", src: "https://static-cdntw.hep200512.com/sweh-assets/trophy.svg", alt: "trophy" }) })), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "leaderboard-header--title" }, { children: data.tournamentName })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "leaderboard-header--info" }, { children: defaultColumns.map(function (column, idx) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "leaderboard-header--info-item" }, { children: [(0, jsx_runtime_1.jsx)("span", { children: column.title }), (0, jsx_runtime_1.jsx)(LeaderboardHeaderSubItem_1.LeaderboardHeaderSubItem, { mainText: column.mainText, secondaryText: column.secondaryText })] }), idx)); }) }))] })] })) })), (0, jsx_runtime_1.jsx)(Modal_1.default, __assign({ addClickOutsideListener: true, onClose: onCloseModal, open: openModal }, { children: function (ref) { return (0, jsx_runtime_1.jsxs)("div", __assign({ ref: ref, className: "leaderboard-body--modal" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "leaderboard-body--modal-header" }, { children: (0, jsx_runtime_1.jsx)("span", { children: data.tournamentName }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "leaderboard-body--modal-body" }, { children: games.map(function (game, idx) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "leaderboard-body--modal-body--game" }, { children: (0, jsx_runtime_1.jsx)("img", { onClick: openGame(game.code), alt: game.code, onError: onImgError, src: "https://cdn.stage.skywind360.com/assets/thumbnail_games/".concat(game.code, ".png") }) }), idx)); }) }))] })); } })), tournamentRules && (0, jsx_runtime_1.jsx)(Modal_1.default, __assign({ open: rulesModal, addClickOutsideListener: true, onClose: onCloseRulesModal }, { children: function (ref) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ ref: ref, className: "leaderboard-body--modal" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "leaderboard-body--modal-header" }, { children: (0, jsx_runtime_1.jsxs)("span", { children: ["Rules for ", data.tournamentName] }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "leaderboard-body--modal-body" }, { children: (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: tournamentRules } }) }))] }))); } }))] }));
};
exports.LeaderboardHeader = LeaderboardHeader;
